import React, { useEffect, useState, useRef } from 'react';
import { sendEventsToAnalyticsSystems } from '../utils/analytics';
import BackIconWhite from '../assets/icons/BackIconWhite.png';
import VideoSection from './VideoSection';
import closeICon from '../assets/images/closeIcon.png';
import playICon from '../assets/images/playIcon.png';
import roundedback from '../assets/images/roundedBack.png';
import Loader from '../components/Loader';

export const InhalerTraining = () => {
  const [language, setLanguage] = useState('English');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [appVersion, setAppVersion] = useState(null);
  const [appAging, setAppAging] = useState('');
  const [uuid, setUuid] = useState('');
  const [data, setData] = useState([]);
  const [langCode, setLangCode] = useState('en');
  const [loading, setLoading] = useState(false);
  const [accessToken, setaccessToken] = useState('');
  const [cohort, setCohort] = useState('');
  const mainPlayerRef = useRef(null);
  const [inhalerType, setInhalerType] = useState('');

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const changeLanguage = (lang, code) => {
    setLanguage(lang);
    setLangCode(code);
    setIsDropdownOpen(false);
    const payload = {
      training_language: lang,
      cohort: cohort,
      App_aging: appAging,
      inhaler_user: 'Yes',
    };
    sendEventsToAnalyticsSystems('inhaler_change_language', payload, uuid);
  };
  const getInhalerData = async () => {
    setLoading(true)
    const response = await fetch(`${process.env.REACT_APP_COMMON_URL}/v1/inhaler-training?lang=${langCode}`, {
      method: 'GET',
      headers: { accesstoken: accessToken },
    });
    const result = await response.json();
    if (result?.response?.code === 200) {
      setLoading(false);
      setData(result?.data);
    }
  };

  useEffect(() => {
    if(langCode && accessToken){
      getInhalerData();
    }
  }, [langCode,accessToken]);

  useEffect(() => {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'PWA_READY' })
    );
    
    let reactNativePayload = { type: 'HIDE_BACK_ARROW', key: 205 };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
  }, []);


  const handleBackToHome = () => {
    let reactNativePayload = { type: 'HIDE_INTERNAL_PWA', key: 207 };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    const payload = {
      training_language: language,
      cohort: cohort,
      App_aging: appAging,
      inhaler_user: 'Yes',
      inhaler_name : inhalerType
    };
    sendEventsToAnalyticsSystems('back_inhaler_training', payload, uuid);
  };

  const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const getYouTubeThumbnailUrl = (url) => {
    const videoId = getYouTubeVideoId(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : null;
  };

  const openVideoModal = (video) => {
    if (mainPlayerRef.current && mainPlayerRef.current.pauseVideo) {
      mainPlayerRef.current.pauseVideo();
    }

    setSelectedVideo(video);
    setShowModal(true);
    const payload = {
      training_language: language,
      cohort: cohort,
      App_aging: appAging,
      inhaler_user: 'Yes',
      tap_type: video?.title,
    };
    sendEventsToAnalyticsSystems('inhaler_training_screen_tap', payload, uuid);
  };

  const closeVideoModal = () => {
    setShowModal(false);
    setSelectedVideo(null);
  };

  const setMainPlayerReference = (playerInstance) => {
    mainPlayerRef.current = playerInstance;
  };

  useEffect(() => {
    const listenMessage = (msg) => {
      try {
        // Check if msg.data exists
        if (!msg.data) return;

        // Handle the message based on its type
        let messageData;
        if (typeof msg.data === 'string') {
          // Only try to parse if it's a string and looks like JSON
          if (msg.data.startsWith('{') || msg.data.startsWith('[')) {
            try {
              messageData = JSON.parse(msg.data);
            } catch (e) {
              console.warn('Failed to parse message data as JSON:', e);
              return;
            }
          } else {
            // Not JSON string, skip processing
            return;
          }
        } else if (typeof msg.data === 'object') {
          // If it's already an object, use it directly
          messageData = msg.data;
        } else {
          // Unknown data type, skip processing
          return;
        }

        // Extract profile data if it exists
        const profileData = messageData?.data?.profileData;
        if (profileData) {
          setUuid(profileData.uuid || '');
          setaccessToken(profileData.accessToken || '');
          setAppVersion(profileData.appVersion || '');
          setAppAging(profileData.appAging || '');
          setCohort(profileData.cohort || '');
        }
      } catch (error) {
        console.warn('Error processing message:', error);
      }
    };

    // Add event listeners
    if (document.addEventListener) {
      document.addEventListener('message', listenMessage, false);
    } else if (document.attachEvent) {
      document.attachEvent('onmessage', listenMessage);
    }

    if (window.addEventListener) {
      window.addEventListener('message', listenMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', listenMessage);
    }

    // Cleanup function
    return () => {
      if (document.removeEventListener) {
        document.removeEventListener('message', listenMessage);
      } else if (document.detachEvent) {
        document.detachEvent('onmessage', listenMessage);
      }

      if (window.removeEventListener) {
        window.removeEventListener('message', listenMessage);
      } else if (window.detachEvent) {
        window.detachEvent('onmessage', listenMessage);
      }
    };
  }, []);

  
  useEffect(() => {
    const payload = {
      training_language: language,
      cohort: cohort,
      App_aging: appAging,
      inhaler_user: 'Yes',
    };
    if (language && cohort && appAging) {
      sendEventsToAnalyticsSystems('inhaler_training_screen', payload, uuid);
    }
  }, [language,cohort,appAging]);

  useEffect(() => {
    if (data && data.banner_url) {
      try {
        const url = new URL(data.banner_url);
        const inhalerTypeValue = url.searchParams.get('inhaler_type');
        if (inhalerTypeValue) {
          setInhalerType(inhalerTypeValue);
        }
      } catch (error) {
        console.error("Error parsing banner URL:", error);
        setInhalerType('Invalid URL');
      }
    }
  }, [data]);

  const inhalerBannerClick = () => {
    const payload = {
      training_language: language,
      cohort: cohort,
      App_aging: appAging,
      inhaler_user: 'Yes',
      tap_value : "inhaler technique",
      inhaler_name : inhalerType
    };
    sendEventsToAnalyticsSystems('inhaler_training_screen_tap', payload, uuid);
  };


  if (loading || !accessToken){
    return <Loader/>
  }
  return (
    <div>
      <nav className="bg-[#FFFFFF] w-full z-20 top-0 start-0">
        <div className="max-w-screen-xl flex items-center justify-between mx-auto p-4 relative">
          <div className="absolute left-4">
            <a onClick={handleBackToHome} href="https://share.cdhl.in/kNrr">
              <img src={roundedback} height={50} width={50} alt="Back Icon" />
            </a>
          </div>
          <div className="w-3/4 mx-auto">
            <p className="text-2xl font-semibold text-center text-[#000000]">{data?.page_header}</p>
          </div>
        </div>
      </nav>
      <div className="bg-[#FFF4E4] flex justify-center px-5 gap-3 py-4">
        <p className="text-[#141414] font-medium text-sm">{data?.language_title}</p>
        <div className="relative mb-2">
          <button
            onClick={toggleDropdown}
            className="flex items-center text-[#72B53D] ml-auto border-b-[#72B53D] border-b-2"
          >
            <span className="mr-1 text-sm">{language}</span>
            <span>
              <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 0.689453H1.82764L7.41384 6.89635L13 0.689453Z"
                  fill="#72B53D"
                  stroke="#72B53D"
                  strokeWidth="1.24138"
                />
              </svg>
            </span>
          </button>
          {isDropdownOpen && (
            <div className="absolute left-0 h-52 overflow-y-scroll mt-2 w-24 bg-white border border-gray-200 rounded shadow-lg z-50">
              {data?.language_data?.map((item) => (
                <button
                  key={item.id}
                  className="block w-full text-left px-2 text-xs py-2 hover:bg-gray-100"
                  onClick={() => changeLanguage(item.name, item.code)}
                >
                  {item.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="px-12 py-5">
        <p className="text-center text-lg text-[#303030] font-semibold">{data?.main_section?.title}</p>
      </div>
      <div>
        <VideoSection onPlayerReady={setMainPlayerReference} url={data?.main_section?.url} />
      </div>
      <div className="flex justify-center px-8 py-5 cursor-pointer">
        <a href={data?.banner_url}>
           <img onClick={inhalerBannerClick} src={data?.banner_image} alt="Inhaler Banner" />
        </a>
      </div>
      <div className="px-6">
        <p className="text-lg text-[#141414] font-semibold mb-5">{data?.child_section?.header}</p>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4">
          {data?.child_section?.video_list?.map((video) => (
            <div key={video.url} onClick={() => openVideoModal(video)} className="cursor-pointer">
              <div className="relative">
                <img
                  src={getYouTubeThumbnailUrl(video.url)}
                  alt={video.title}
                  className="w-full h-auto object-cover rounded-lg"
                />
                <div className="absolute inset-0 flex items-center justify-center rounded">
                  <div className="">
                    <img src={playICon} width={45} height={45} className="opacity-75" alt="Play Icon" />
                  </div>
                </div>
              </div>
              <p className="text-[#6C6C6C] text-sm font-medium py-3">{video.title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {showModal && selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="rounded-lg w-full max-w-3xl">
            <button onClick={closeVideoModal} className="float-right mb-2 mr-2">
              <img src={closeICon} width={30} height={30} alt="Close Icon" />
            </button>
            <div className="flex justify-between items-center mb-4">
              {/* <h3 className="text-lg font-semibold">{selectedVideo.title}</h3> */}
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                className="w-full h-56 md:h-96"
                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                  selectedVideo.url,
                )}?autoplay=1&modestbranding=1&showinfo=0&rel=0&iv_load_policy=3`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
